module.exports = __webpack_public_path__ + "img/full.5d3cf42b.svg";